module.exports = __webpack_public_path__ + "media/images/hatebu-icon-6179d03444295b67f2c211bef093a307.svg";